export default class Alerta {

    constructor(numseqale=0, nomsisale='', tipbxaalesis='M', nomtipalesis='', msgale='', urlmsgale='', staacaurgsis=false, dtacad='', dtavlzalepoa='', codigoArea='') {
        this.id = numseqale
        this.titulo = nomtipalesis || '';
        this.sistema = nomsisale
        this.mensagem = msgale
        this.url = urlmsgale
        this.cadastradoEm = dtacad
        this.visualizadoEm = dtavlzalepoa
        this.urgente = staacaurgsis
        this.manual = tipbxaalesis === 'M'
        this.codigoArea = codigoArea;
        this.area = null
        this.estendido = false
    }

    getKey() {
        return `${this.id}:${this.sistema}`;
    }

    isVisualizado() {
        return !!this.visualizadoEm
    }

    podeAdiar(){
        return !this.manual;
    }

    podeResolver(){
        return this.manual;
    }

    podeSeguir(){
        return !this.manual && this.url;
    }

    setArea(area){
        this.area = area;
    }

    static buildFromJson(json={}){
        return new Alerta(
            json.numseqale,
            json.nomsisale, 
            json.tipbxaalesis,
            json.titalesis, 
            json.msgale,
            json.urlmsgale,
            json.staacaurgsis === "S",
            json.dtacad, 
            json.dtavlzalepoa,
            json.codigoArea,
        )
    }
}